import React from 'react';
import { PillUnit } from '@mark43/cad-api';
import { EventPanelUnitsContext } from './event-panel-units-context';
import { useIntegratedEventUnitsState } from '../event-state/use-integrated-event-units-state';

export function EventPanelUnitsProvider(props: {
    children: React.ReactNode;
    initialUnits?: PillUnit[];
    eventId?: number;
}): React.ReactElement {
    const { units } = useIntegratedEventUnitsState({
        eventId: props.eventId,
        initialUnits: props.initialUnits,
    });
    return (
        <EventPanelUnitsContext.Provider value={units}>
            {props.children}
        </EventPanelUnitsContext.Provider>
    );
}
